import { createSlice } from "@reduxjs/toolkit"

const authSlice = createSlice({
    name: "auth",
    initialState: {
        isLogged: null,
        forgotPassword: 0,
        forgotPasswordEmail: '',
        forgotPasswordReason: null,
        newRegistration: 0,
        mustSetPassword: false,
        currentUser: {},
        permissions: [],
        plugins: [],
        userId: "",
        systemRole: "",
        mfaPending: false,
        mfaToken: null,
        mfaError: null,
        mfaSource: null,
        trustedDevices: [],
    },
    reducers: {
        logIn() { },
        logOut() { },
        isLoggedIn() { },
        forgotPassword() { },
        newRegistration() { },
        setIsLogged(state, action) {
            const { isLogged } = action.payload;
            return { ...state, isLogged };
        },
        setCurrentUser(state, action) {
            const { user, id, role, permissions, plugins, mustSetPassword } = action.payload;
            return { ...state, currentUser: user, userId: id, systemRole: role, permissions: permissions, plugins: plugins ?? state.plugins, mustSetPassword: mustSetPassword ?? !!user?.mustSetPassword };
        },
        setMustSetPassword(state, action) {
            return { ...state, mustSetPassword: !!action.payload?.mustSetPassword };
        },
        setForgotPassword(state, action) {
            const { step, email, reason } = action.payload;
            const next = { ...state };
            if (step !== undefined) next.forgotPassword = step;
            if (email !== undefined) next.forgotPasswordEmail = email;
            if (reason !== undefined) next.forgotPasswordReason = reason;
            if (step === 0) next.forgotPasswordReason = null;
            return next;
        },
        setNewRegistration(state, action) {
            const { step } = action.payload;
            if (step !== undefined)
                return { ...state, newRegistration: step }
            return { ...state }
        },
        setUserPreferences(state, action) {
            const { preferences } = action.payload;
            if (state.currentUser) {
                return {
                    ...state,
                    currentUser: { ...state.currentUser, preferences: preferences }
                };
            }
            return state;
        },
        setPinnedAccounts(state, action) {
            const { pinnedAccounts } = action.payload;
            if (state.currentUser) {
                return {
                    ...state,
                    currentUser: {
                        ...state.currentUser,
                        preferences: {
                            ...state.currentUser.preferences,
                            pinnedProjects: pinnedAccounts
                        }
                    }
                };
            }
            return state;
        },
        setMfaPending(state, action) {
            const { mfaToken, source } = action.payload || {};
            return { ...state, mfaPending: true, mfaToken: mfaToken || null, mfaSource: source || 'login', mfaError: null };
        },
        clearMfa(state) {
            return { ...state, mfaPending: false, mfaToken: null, mfaError: null, mfaSource: null };
        },
        setMfaError(state, action) {
            return { ...state, mfaError: action.payload?.message || null };
        },
        setTwoFactorEnabled(state, action) {
            const enabled = !!action.payload?.enabled;
            if (!state.currentUser) return state;
            return {
                ...state,
                currentUser: {
                    ...state.currentUser,
                    twoFactor: { ...(state.currentUser.twoFactor || {}), enabled },
                },
            };
        },
        setTrustedDevices(state, action) {
            return { ...state, trustedDevices: action.payload?.devices || [] };
        },
    }
});

export const {
    logIn,
    logOut,
    isLoggedIn,
    forgotPassword,
    newRegistration,
    setIsLogged,
    setCurrentUser,
    setForgotPassword,
    setNewRegistration,
    setMustSetPassword,
    setPinnedAccounts,
    setUserPreferences,
    setMfaPending,
    clearMfa,
    setMfaError,
    setTwoFactorEnabled,
    setTrustedDevices,
} = authSlice.actions;
export default authSlice.reducer;
